export enum AccountDeletionStatus {
  noStatus = 'noStatus',
  deleteProcessing = 'deleteProcessing',
  accountDeleted = 'accountDeleted',
  userNotFound = 'userNotFound',
  hasErrored = 'error',
  tokenExpired = 'expired',
}
